// extracted by mini-css-extract-plugin
module.exports = {"metrics_pm":"MemorandumValues_metrics_pm__2x_zr","column_metrics":"MemorandumValues_column_metrics__3XFqb"};